import { CompatiblePluginEventType } from "roosterjs";
/**
 * Rooster plugin that blocks pasting an image into the editor
 */ export class RoosterBlockImagePastePlugin {
    /**
     * Gets the name of the plugin
     */ getName() {
        return "RoosterBlockImagePastePlugin";
    }
    /**
     * Plugin initialize lifecycle hook
     */ initialize(editor) {
    /* do nothing */ }
    /**
     * Plugin dispose lifecycle hook
     */ dispose() {
    /* do nothing */ }
    /**
     * Plugin event hook
     */ onPluginEvent(event) {
        // Check if the event is BeforePasteEvent
        if (event.eventType === CompatiblePluginEventType.BeforePaste) {
            // Clear the image data from the clipboard
            event.clipboardData.image = null;
            // Search fragment for any images and remove
            this.searchAndRemoveImages(event.fragment);
            // Also remove any images from the clipboardData html
            if (event.clipboardData.html) {
                event.clipboardData.html = event.clipboardData.html.replace(/<img[^>]*>/g, "");
            }
        }
    }
    /**
     * Searches a node's children for images and removes them
     * @param node A document fragment or child node
     */ searchAndRemoveImages(node) {
        const children = node.childNodes;
        for (const child of children){
            if (this.isChildNodeAnImage(child)) {
                node.removeChild(child);
            } else {
                this.searchAndRemoveImages(child);
            }
        }
    }
    /**
     * Determines if a child node is an image
     * @param node The node to check
     */ isChildNodeAnImage(node) {
        if (node == null || node.nodeName == null) {
            return false;
        }
        return node.nodeName.toLowerCase() === "img";
    }
}
